"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentAddress = void 0;
const typeorm_1 = require("typeorm/browser");
const class_transformer_1 = require("class-transformer");
let PaymentAddress = class PaymentAddress {
};
__decorate([
    (0, class_transformer_1.Exclude)(),
    (0, typeorm_1.PrimaryGeneratedColumn)({
        type: 'bigint',
        name: 'id',
    }),
    __metadata("design:type", String)
], PaymentAddress.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        default: 'DE',
        length: 2,
        name: 'country',
    }),
    __metadata("design:type", String)
], PaymentAddress.prototype, "country", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        name: 'title',
        length: 128,
    }),
    __metadata("design:type", String)
], PaymentAddress.prototype, "title", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        name: 'last_name',
        length: 80,
    }),
    __metadata("design:type", String)
], PaymentAddress.prototype, "lastName", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        name: 'first_name',
        length: 40,
    }),
    __metadata("design:type", String)
], PaymentAddress.prototype, "firstName", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        name: 'organization',
        length: 80,
    }),
    __metadata("design:type", String)
], PaymentAddress.prototype, "organization", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        name: 'email',
        length: 256,
    }),
    __metadata("design:type", String)
], PaymentAddress.prototype, "email", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        name: 'postal_code',
        length: 20,
    }),
    __metadata("design:type", String)
], PaymentAddress.prototype, "postalCode", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        name: 'street',
        length: 255,
    }),
    __metadata("design:type", String)
], PaymentAddress.prototype, "street", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        name: 'street2',
        length: 255,
    }),
    __metadata("design:type", String)
], PaymentAddress.prototype, "street2", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        name: 'city',
        length: 40,
    }),
    __metadata("design:type", String)
], PaymentAddress.prototype, "city", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        name: 'region',
        length: 80,
    }),
    __metadata("design:type", String)
], PaymentAddress.prototype, "region", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        name: 'phone',
        length: 40,
    }),
    __metadata("design:type", String)
], PaymentAddress.prototype, "phone", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        name: 'mobile_phone',
        length: 40,
    }),
    __metadata("design:type", String)
], PaymentAddress.prototype, "mobilePhone", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    (0, typeorm_1.CreateDateColumn)({
        type: 'timestamp with time zone',
        name: 'created_at',
    }),
    __metadata("design:type", Date)
], PaymentAddress.prototype, "createdAt", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    (0, typeorm_1.UpdateDateColumn)({
        type: 'timestamp with time zone',
        name: 'updated_at',
    }),
    __metadata("design:type", Date)
], PaymentAddress.prototype, "updatedAt", void 0);
PaymentAddress = __decorate([
    (0, typeorm_1.Entity)('address', { schema: 'payment' })
], PaymentAddress);
exports.PaymentAddress = PaymentAddress;
//# sourceMappingURL=payment-address.js.map